"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
var _commonUtils = require("@sial/common-utils");
var useBannerTracking = function useBannerTracking(component, isHomepage) {
  var isGTMEnabled = function isGTMEnabled() {
    var _window;
    return typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer);
  };
  var _useState = (0, _react.useState)([]),
    visibleBanners = _useState[0],
    setVisibleBanners = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    visitedBanners = _useState2[0],
    setVisitedBanners = _useState2[1];
  var NotAvailable = 'Not available';
  var componentType = 'carousel';
  //TODO: For banners other than homepage, we are sending 'hero-banner' as creativeSlot.
  //This value might change when we start tracking non-homepage banners.
  var creativeSlot = isHomepage ? 'hero_banner - homepage' : 'hero-banner';
  var itemType = isHomepage ? 'homepage' : 'null';
  var getVisibleBanners = function getVisibleBanners() {
    var _document;
    var carousalParentEl = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector('.aem-ms-carousel');
    var bannerList = carousalParentEl === null || carousalParentEl === void 0 ? void 0 : carousalParentEl.querySelectorAll('.slide:not(.prev-cloned):not(.next-cloned)');
    if (bannerList !== null && bannerList !== void 0 && bannerList.length) {
      var customBannerList = [];
      bannerList.forEach(function (item, index) {
        var banner = {
          id: "banner-item-".concat(index + 1),
          isVisible: item.className.includes('slide-visible')
        };
        customBannerList.push(banner);
      });
      return customBannerList.filter(function (visibleProduct) {
        return visibleProduct.isVisible;
      });
    } else {
      return [];
    }
  };
  var getPromotionEventData = function getPromotionEventData() {
    var _document2, _currentItem$;
    var promotions = [];
    var carousalParentEl = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.querySelector('.aem-ms-carousel');
    var currentItem = carousalParentEl === null || carousalParentEl === void 0 ? void 0 : carousalParentEl.querySelectorAll('.slide-visible a');
    var gaParameters = currentItem && ((_currentItem$ = currentItem[0]) === null || _currentItem$ === void 0 ? void 0 : _currentItem$.getAttribute('ga_product'));
    var gaParametersArr = gaParameters === null || gaParameters === void 0 ? void 0 : gaParameters.split('|');
    var promoObj = {
      id: gaParametersArr && gaParametersArr[0] || NotAvailable,
      name: gaParametersArr && gaParametersArr[1] || NotAvailable,
      creative: gaParametersArr && gaParametersArr[2] || NotAvailable
    };
    promotions.push(promoObj);
    return promotions;
  };
  var getGA4Payload = (0, _react.useCallback)(function (promoData, activeSlide) {
    var currentVisibleBanner = promoData.length ? promoData[0] : null;
    var ga4Payload = {
      creative_slot: creativeSlot,
      items: [{
        creative_name: (currentVisibleBanner === null || currentVisibleBanner === void 0 ? void 0 : currentVisibleBanner.creative) !== 'null' && (currentVisibleBanner === null || currentVisibleBanner === void 0 ? void 0 : currentVisibleBanner.creative) || '',
        promotion_id: (currentVisibleBanner === null || currentVisibleBanner === void 0 ? void 0 : currentVisibleBanner.id) || '',
        promotion_name: (currentVisibleBanner === null || currentVisibleBanner === void 0 ? void 0 : currentVisibleBanner.name) || '',
        index: activeSlide || 0,
        item_id: '',
        item_brand: '',
        item_list_id: itemType,
        item_list_name: itemType
      }]
    };
    return ga4Payload;
  }, [creativeSlot, itemType]);
  var handleBannerClick = function handleBannerClick(activeSlide) {
    var visitedHero = (0, _toConsumableArray2.default)(visitedBanners);
    if (!visitedBanners.length) {
      visitedHero = (0, _toConsumableArray2.default)(visibleBanners);
    }
    var currentVisibleHero = getVisibleBanners();
    var newVisibleBanner = currentVisibleHero.filter(function (o1) {
      var _visitedHero;
      return !((_visitedHero = visitedHero) !== null && _visitedHero !== void 0 && _visitedHero.some(function (o2) {
        return o1.id === o2.id;
      }));
    });
    if (newVisibleBanner.length) {
      var promoData = getPromotionEventData();
      var ga4Payload = getGA4Payload(promoData, activeSlide);
      var showGTMTag = false;
      if (isGTMEnabled()) {
        showGTMTag = true;
        _commonUtils.Analytics.sendInternalPromotionsEvent(promoData, true, showGTMTag, ga4Payload);
      }
      _commonUtils.Analytics.sendTealiumInternalPromotionsEvent(promoData, ga4Payload);
      visitedHero = [].concat((0, _toConsumableArray2.default)(visitedHero), [newVisibleBanner[0]]);
      setVisitedBanners(visitedHero);
    }
  };
  var trackBannerClickEventGA = function trackBannerClickEventGA(slide) {
    //timeout to make sure next slide is visible before triggering the tracking event.
    setTimeout(function () {
      handleBannerClick(slide);
    }, 100);
  };
  var trackBannerRedirectEventGA = function trackBannerRedirectEventGA(event, activeSlide) {
    var heroElement = event.currentTarget;
    var gaParameters = heroElement && heroElement.getAttribute('ga_product');
    var promoDetailsArr = (gaParameters === null || gaParameters === void 0 ? void 0 : gaParameters.split('|')) || [];
    var promoData = [{
      id: promoDetailsArr[0],
      name: promoDetailsArr[1],
      creative: promoDetailsArr[2]
    }];
    var ga4Payload = getGA4Payload(promoData, activeSlide);
    var showGTMTag = false;
    if (isGTMEnabled()) {
      showGTMTag = true;
      _commonUtils.Analytics.sendInternalPromotionsClickEvent(gaParameters, true, showGTMTag, ga4Payload);
    }
    _commonUtils.Analytics.sendTealiumInternalPromotionsClickEvent(gaParameters, ga4Payload);
  };
  (0, _react.useEffect)(function () {
    if (componentType === component) {
      var trackBannerViewEventGA = function trackBannerViewEventGA() {
        var promoData = getPromotionEventData();
        var ga4Payload = getGA4Payload(promoData, 1); //For promotional tracking of a carousal on page load, the 1st hero banner will always have index as 1.
        var showGTMTag = false;
        if (isGTMEnabled()) {
          showGTMTag = true;
          _commonUtils.Analytics.sendInternalPromotionsEvent(promoData, true, showGTMTag, ga4Payload);
        }
        _commonUtils.Analytics.sendTealiumInternalPromotionsEvent(promoData, ga4Payload);
        var visibleBanners = getVisibleBanners();
        setVisibleBanners(visibleBanners);
      };
      trackBannerViewEventGA();
    }
  }, [component, getGA4Payload]);
  return [trackBannerClickEventGA, trackBannerRedirectEventGA];
};
var _default = useBannerTracking;
exports.default = _default;